const villaSec2_Object = payload => {
  return {
    type: "villaSec2",
    payload
  };
};

export default villaSec2_Object;
